module.exports = __webpack_public_path__ + "img/logo.5d3e8eb9.png";